export const PhoneNumberConstants = {
    InternationalPhoneNumber: "+1 617 770-3000",
    UsPhoneNumber: "+1 800 344-3555",
    AltUsPhoneNumber: "+1 855 274-6525",
    MexicoPhoneNumber: "+95 800-844-6058",
} as const;

export const SupportConstants = {
    ...PhoneNumberConstants,
    BusinessHours: "Mon-Fri, 8:30 am - 5:00 pm EST",
    NonAbbreviatedBusinessHours:
        "Monday through Friday, 8:30 a.m-5:00 p.m. EST",
    CustomerServiceEmail: "custserv@nfpa.org",
} as const;
